import Typography, { TypographyProps } from "@mui/material/Typography";

export type { TypographyProps };

export default Typography;
